export const why=[
  {
    nameWhy:'Augmenter votre visiblité',
    pictureWhy:process.env.PUBLIC_URL + '/assets/voir.png',
    titleWhy:'Augmenter votre visibilité sur le web ',
    detailWhy:[<strong key="11">Augmenter votre visibilité</strong>,
      ' sur le web pour promouvoir votre société auprès de vos prospects ainsi que de vos clients.', <br key='1'></br>,
      <strong key="12">Gérer votre image</strong>,
      ' afin de mettre votre société en valeur sur mesure.',<br key='2'></br>,
      <strong key="12">Une visibilité accrue sur le web</strong>,
      ' permet de toucher un public plus large et peut vous aider à atteindre de nouveaux clients, à renforcer votre crédibilité, à rester compétitif']
  },
  {
    nameWhy:'Elargir votre base',
    pictureWhy:process.env.PUBLIC_URL + '/assets/elargirBaseClient.png',
    titleWhy:'Elargir votre base de clientèle',
    detailWhy:[ <strong key="13">Toucher de nouveaux prospects</strong>,
      ' via le web et faciliter la prise de contact via un formulaire directement sur votre site vitrine. ', <br key='4'></br>,
      <strong key="13">Plus vous avez de clients</strong>,
      ', plus vous pouvez vendre de produits ou de services', <br key='5'></br>,
      <strong key="14">Elargir sa base de clients permet</strong>,
      ' de croître, de réduire les risques, de découvrir de nouvelles opportunités et d\'améliorer la rentabilité de l\'entreprise.']
  },
  {
    nameWhy:'Rassurer vos clients',
    pictureWhy:process.env.PUBLIC_URL + '/assets/prospect.png',
    titleWhy:'Rassurer vos clients et vos prospects',
    detailWhy:[ <strong key="15">Votre site vitrine est le miroir de votre activité</strong>,
      ' et la manière dont les visiteurs vont vous percevoir. Démarquez-vous en réalisant votre site vitrine sur mesure.',<br key='7'></br>,
      <strong key="16">Les clients rassurés sont plus enclins</strong>,
      ' à rester fidèles et ont tendance à donner des avis positifs sur une entreprise', <br key='8'></br>,
      <strong key="17">Rassurer vos clients et vos prospects</strong>,
      ' permet de les fidéliser, d\'augmenter les ventes, d\'améliorer la réputation de votre entreprise, ']
  },
  {
    nameWhy:'Présenter votre activité',
    pictureWhy:process.env.PUBLIC_URL + '/assets/presentation.jpg',
    titleWhy:'Présenter votre activité',
    detailWhy:[<strong key="18">Le site vitrine est un moyen simple</strong>,
      ' de présenter et de mettre en avant votre activité.',<br key='9'></br>,
      <strong key="19">Présenter votre activité</strong>,
      ' Permet de sensibiliser les gens à ce que vous faites',<br key='10'></br>,
      <strong key="20">Développer des partenariats</strong>,
      ' avec d\'autres entreprises',<br key='11'></br>,
      <strong key="21"> et permet de construire une image de marque forte</strong>,
      ' qui attirera les clients potentiels et renforcera la fidélité des clients existants']
  },


];